import { Button } from '@chronosphereio/chrono-ui';
import { useAIEdit } from './ai-edit-context';
import { useEditWithAIButtonSx } from './edit-with-ai-button-sx';

/**
 * "Edit with AI" button that opens the AI edit panel. Typically rendered
 * via QueryEditor.Input's `endAdornment` prop or in a toolbar.
 *
 * Self-gating: returns null when the AI edit panel is already open.
 */
export function AIEditButton() {
  const { isOpen, open } = useAIEdit();
  const sx = useEditWithAIButtonSx();

  if (isOpen) return null;

  return (
    <Button size="small" variant="secondary" data-testid="edit-with-ai-button" onClick={open} sx={sx}>
      Edit with AI
    </Button>
  );
}
